import React from "react";

const Dashboard = () => {
  return <h2>This is Dashboard</h2>;
};

export default Dashboard;
